import { IconButton, InputAdornment } from '@mui/material';
import { useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Iconify from '../../../../reusable-components/iconify';
import { formStyle } from '../TransitionStyles';

FormYearPickerField.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
};

export default function FormYearPickerField({ fieldName, fieldAttributes, focusedField, setFocusedField }) {
  const { control } = useFormContext();
  const [open, setOpen] = useState(false);
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

  const fieldDisabled = isCanceled || !fieldAttributes.isEditable;

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field, fieldState }) => (
        <DatePicker
          views={['year']}
          openTo="year"
          format="yyyy"
          value={field.value ? new Date(Number(field.value), 0, 1) : null}
          onChange={(newValue) => {
            const normalized =
              newValue instanceof Date && !Number.isNaN(newValue.getTime()) ? String(newValue.getFullYear()) : null;
            field.onChange(normalized);
          }}
          disabled={fieldDisabled}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          slotProps={{
            textField: {
              fullWidth: true,
              placeholder: !fieldDisabled ? 'YYYY' : '',
              size: 'small',
              error: !!fieldState.error,
              helperText: fieldState.error?.message,
              onFocus: () => setFocusedField?.(fieldName),
              onBlur: () => setFocusedField?.(null),
              onClick: () => setOpen(true),
              sx: formStyle,
              InputProps: {
                endAdornment: (
                  <>
                    {!fieldDisabled && (
                      <InputAdornment position="end">
                        <IconButton size="small" edge="end" tabIndex={-1} onClick={() => setOpen(true)}>
                          <Iconify icon="eva:calendar-outline" />
                        </IconButton>
                      </InputAdornment>
                    )}
                    {field.value && focusedField === fieldName && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          edge="end"
                          tabIndex={-1}
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpen(false);
                            field.onChange(null);
                          }}
                        >
                          <Iconify icon="eva:close-outline" />
                        </IconButton>
                      </InputAdornment>
                    )}
                  </>
                ),
              },
            },
          }}
        />
      )}
    />
  );
}
